import React from "react";
import { Box, Container, Typography, Stack, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { SectionContainer, PageTitle } from "../Components/StyledComponents";
import Seo from "../Components/Seo";
import {
  BUSINESS_EMAIL,
  BUSINESS_NAME,
} from "../config/business";

const Privacy = () => (
  <Box>
    <Seo
      title="Privacy en Cookies | Meester Stoffeerders"
      description="Lees hoe Meester Stoffeerders omgaat met privacy, cookies en analytische tools zoals Google Analytics en Microsoft Clarity."
      path="/privacy"
    />
    <SectionContainer>
      <Container maxWidth="md">
        <PageTitle>Privacy en Cookies</PageTitle>
        <Stack spacing={3} sx={{ mt: 4 }}>
          <Typography variant="body1" color="text.secondary">
            {BUSINESS_NAME} gebruikt alleen analytische cookies nadat u daarvoor toestemming geeft.
            Deze pagina legt in het kort uit welke gegevens we gebruiken en hoe u uw keuze later kunt wijzigen.
          </Typography>

          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, color: "primary.main", mb: 1 }}>
              Welke tools gebruiken we?
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Met Google Analytics meten we bezoekaantallen en paginagebruik. Met Microsoft Clarity
              bekijken we hoe bezoekers klikken, scrollen en door de site bewegen. Deze tools helpen ons
              de website gebruiksvriendelijker te maken.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, color: "primary.main", mb: 1 }}>
              Wanneer laden deze tools?
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Alleen nadat u expliciet toestemming geeft via de cookiebanner of via de cookie-instellingen
              in de footer. Zonder toestemming blijven deze analysetools uitgeschakeld.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, color: "primary.main", mb: 1 }}>
              Toestemming wijzigen
            </Typography>
            <Typography variant="body1" color="text.secondary">
              U kunt uw keuze later altijd wijzigen via de link <strong>Cookie-instellingen</strong> in de footer.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, color: "primary.main", mb: 1 }}>
              Contact
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Heeft u vragen over privacy of cookies? Neem contact op via{" "}
              <Link href={`mailto:${BUSINESS_EMAIL}`}>{BUSINESS_EMAIL}</Link>.
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary">
            Terug naar <Link component={RouterLink} to="/">de homepage</Link>.
          </Typography>
        </Stack>
      </Container>
    </SectionContainer>
  </Box>
);

export default Privacy;
